var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriorityDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2487 22.0828C19.153 22.0828 19.0557 22.059 18.9687 22.0104L14.04 19.2769L9.1113 22.0104C8.91478 22.1195 8.6713 22.1049 8.4887 21.9713C8.30783 21.8384 8.21913 21.6113 8.26261 21.3903L9.36 15.9066L5.52696 12.0739C5.3687 11.9157 5.31652 11.6805 5.3913 11.4703C5.46783 11.2595 5.65739 11.1108 5.88 11.0889L11.3322 10.5433L13.5113 5.64193C13.6035 5.43271 13.8104 5.29828 14.04 5.29828C14.2678 5.29828 14.4765 5.43271 14.5687 5.64193L16.7478 10.5433L22.2 11.0889C22.4226 11.1108 22.6122 11.2595 22.687 11.4703C22.7635 11.6805 22.7096 11.9157 22.5513 12.0739L18.72 15.9066L19.8157 21.3903C19.8609 21.6113 19.7722 21.8384 19.5896 21.9713C19.4887 22.0454 19.3687 22.0828 19.2487 22.0828ZM14.04 18.0364C14.1357 18.0364 14.233 18.0609 14.32 18.1087L18.4365 20.3915L17.5235 15.8298C17.4852 15.6398 17.5443 15.4437 17.6817 15.307L20.8696 12.1191L16.2974 11.6621C16.0904 11.6412 15.9096 11.511 15.8261 11.3212L14.04 7.30193L12.2539 11.3212C12.1687 11.511 11.9896 11.6412 11.7826 11.6621L7.21043 12.1191L10.3983 15.307C10.5339 15.4437 10.5948 15.6398 10.5565 15.8298L9.64348 20.3915L13.7583 18.1087C13.847 18.0609 13.9426 18.0364 14.04 18.0364Z",
    fill: "#DA291C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityDefault);
export default __webpack_public_path__ + "static/media/priority-default.71d6b8cabb2ff36e8a6de3287d801df0.svg";
export { ForwardRef as ReactComponent };